import DataLoader from "../Utlis/DataLoader";

const fetchlatestposts = async () => {
  try {
    const response = await DataLoader({
      Path: `/api/v1/posts/latestPost/`,
      Type: "get",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default fetchlatestposts;
